export default {
  header: {
    signIn: 'Đăng nhập',
    signUp: 'Đăng ký'
  },
  userMenu: {
    wallet: 'Ví',
    withdraw: 'Rút tiền',
    transaction: 'Giao dịch',
    myBet: 'Cược của tôi',
    rollover: 'Rollover',
    vault: 'Két sắt',
    profile: 'Hồ sơ',
    settings: 'Cài đặt',
    signOut: 'Đăng xuất',
    signOutTitle: 'Đăng xuất',
    signOutContent: 'Khám phá thế giới tràn ngập phần thưởng và trò chơi hấp dẫn!',
    signOutConfirm: 'Đăng xuất',
    cancel: 'Hủy'
  }
};
